import { Form, InputGroup } from 'react-bootstrap'
import { Copy } from 'lucide-react'
import toast from 'react-hot-toast'

const index = ({
  label,
  value,
  col,
  address = null,
  classNameValue = 'fw-bold',
  type = 'text',
  withCopy = false
}) => {
  const handleCopy = () => {
    if (value && value !== '-') {
      navigator.clipboard.writeText(value)
      toast.success('Copied to clipboard')
    }
  }

  return (
    <Form.Group className={`mb-3 col-md-${col} col-12`} controlId="po">
      <Form.Label
        className={`text-uppercase ${classNameValue}`}
        style={{ fontSize: '13px', letterSpacing: '0.5px' }}
      >
        {label}
      </Form.Label>
      {type === 'text' &&
        (address ? (
          <div
            dangerouslySetInnerHTML={{
              __html: value
            }}
            style={{ backgroundColor: '#e0e0e0', padding: '1rem' }}
            className="w-100 rounded"
          />
        ) : withCopy && value && value !== '-' ? (
          <InputGroup>
            <Form.Control
              value={value}
              readOnly={true}
              className="form-control-readonly"
              style={{
                height: '45px',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
              }}
            />
            <InputGroup.Text
              style={{
                cursor: 'pointer',
                backgroundColor: '#fff',
                borderLeft: 'none',
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px'
              }}
              onClick={handleCopy}
              title="Copy"
            >
              <Copy size={14} className="text-muted" />
            </InputGroup.Text>
          </InputGroup>
        ) : (
          <Form.Control
            value={value}
            readOnly={true}
            className="form-control-readonly"
            style={{ height: '45px' }}
          />
        ))}
      {type === 'select' && (
        <Form.Select
          value={value}
          readOnly={true}
          className="form-control-readonly"
          disabled
          style={{ height: '45px' }}
        >
          <option value={value}>{value}</option>
        </Form.Select>
      )}
    </Form.Group>
  )
}

export default index
